<script>
    import { getCSSVar } from '$lib/utils'
    import Typography from './Typography.svelte'
    import { ChevronCircleRight } from '../Icons'
    export let label = ''
    export let disabled = false
    export let icon = null
    export let size = 'default'
    export let color = getCSSVar('--color-grey-800')
    $: color =
        color.match(/^rgb.+|^#[a-f|A-F|0-9]+|\w+/) && color.slice(0, 2) !== '--'
            ? color
            : getCSSVar(color)
    let args = {
        color: color,
        size: {
            default: 24,
            small: 18,
        },
    }
    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    function mousedown() {
        dispatch('mousedown', {})
    }
    function mouseup() {
        dispatch('mouseup', {})
    }
    function mouseover() {
        dispatch('mouseover', {})
    }
    function mouseout() {
        dispatch('mouseout', {})
    }
    function dblclick() {
        dispatch('dblclick', {})
    }
    function click() {
        dispatch('click', {})
    }
    function contextmenu() {
        dispatch('contextmenu', {})
    }
    function keypress(event) {
        if (['Enter', 'Space'].indexOf(event.code) !== -1) click()
    }
</script>

<div
    tabindex="0"
    on:keypress={keypress}
    class={disabled ? 'disabled' : ''}
    on:click={disabled ? (_) => {} : click}
    on:dblclick={disabled ? (_) => {} : dblclick}
    on:mousedown={disabled ? (_) => {} : mousedown}
    on:mouseup={disabled ? (_) => {} : mouseup}
    on:mouseover={disabled ? (_) => {} : mouseover}
    on:mouseout={disabled ? (_) => {} : mouseout}
    on:contextmenu={disabled ? (_) => {} : contextmenu}
    on:mouseover={(_) => _}
    on:focus={(_) => _}
    on:blur={(_) => _}
>
    {#if icon}
        <svelte:component
            this={icon}
            color={args.color}
            size={args.size[size]}
        />
    {:else}
        <ChevronCircleRight color={args.color} size={args.size[size]} />
    {/if}
    {#if label}
        <!-- <Typography color="grey-800" type={size === 'small' ? 'subtitle-medium' : 'subhead'} style="margin: 0; padding: 0">{label}</Typography> -->
        <a href={null} style={`color: ${color}`} class={size}>{label}</a>
    {:else}
        <!-- <Typography color="grey-800" type={size === 'small' ? 'subtitle-medium' : 'subhead'} style="margin: 0; padding: 0"><slot/></Typography> -->
        <a href={null} style={`color: ${color}`} class={size}><slot /></a>
    {/if}
</div>

<style>
    div {
        display: flex;
        justify-content: center;
        gap: 7px;
        align-items: center;
        user-select: none;
    }
    div:hover {
        cursor: pointer;
    }
    a {
        color: var(--color-grey-800);
    }
    div:hover a {
        text-decoration: underline;
    }

    div.disabled {
        opacity: 0.5;
        cursor: no-drop;
    }
    .default {
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0.5px;
    }
    .small {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        letter-spacing: 0.4px;
    }
</style>
